import { DialogConfirmComponent } from './../../dialog/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { TipoComponenteService } from './../../../service/endereco/tipo-componente.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TipoComponenteModel } from './../../../model/endereco/tipocomponente.mode';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-tipo-componente',
  templateUrl: './tipo-componente.component.html',
  styleUrls: ['./tipo-componente.component.scss']
})
export class TipoComponenteComponent implements OnInit {

  user: any;
  creatorTipoComponente = false;
  editorTipoComponente = false;
  listaTipoComponente = false;
  deletaTipoComponente = false;
  superUser = false;
  arrayString: string;

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public tipoComponente = {} as TipoComponenteModel;
  public tipoComponentes: TipoComponenteModel[];
  public submit = false;
  @ViewChild('cardEdit') targetEl: ElementRef;
  @ViewChild('tipoComponenteInput') tipoComponenteInput: ElementRef;
  public formTipoComponenete: FormGroup;
  public page: ResponsePageable;
  public pageAtual = 0;
  public loading = true;

  constructor(
    private tipoComponenteService: TipoComponenteService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.getAuthority();
    this.listPageTipoComponente(0, 10);

    // Formulário de tipo Componente
    this.formTipoComponenete = this.fb.group({
      id: [null],
      nome: [null, [Validators.maxLength(100), Validators.required]],
      ativo: [null],
    });
  }

  listPageTipoComponente(page, size) {
    this.tipoComponenteService.getPageTipoComponente(page, size).subscribe(res => {
      this.loading = false;
      this.page = res;
      this.tipoComponentes = this.page.content;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro na listagem !');
      this.loading = false;
    });
  }

  listarTipoComponente() {
    this.tipoComponenteService.getTipoComponentes().subscribe(data => {
      this.tipoComponentes = data;
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  addOrEdit() {
    console.log(this.tipoComponente.id);
    if (this.tipoComponente.id != null) {
      this.editarTipoComponente();
    } else {
      this.adicionarTipoComponente();
    }
  }

  limpar() {
    this.submit = false;
    this.tipoComponente.id = null;
    this.tipoComponenteInput.nativeElement.value = '';
    this.tipoComponente.nome = null;
    this.tipoComponente.ativo = false;
  }

  adicionarTipoComponente() {
    this.loading = true;
    if (this.formTipoComponenete.valid) {
      let ativo = this.formTipoComponenete.get('ativo').value;
      if (ativo !== true) {
        this.formTipoComponenete.get('ativo').setValue(false);
      }
      this.tipoComponenteService.adicionarTipoComponente(this.formTipoComponenete.value).subscribe(data => {
        console.log(data);
          this.openSnackBarSuccess(`Tipo de Componente ${data.nome} salvo com sucesso !`);
          this.listPageTipoComponente(0, 10);
          this.submit = false;
          this.formTipoComponenete.reset();
      }, err => {
        console.error(err);
        this.openSnackBarError('Erro ! ' + err.error.message);
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.openSnackBarError('Preencha todos os campos obrigatórios !');
    }
  }

  editarTipoComponente() {
    this.loading = true;
    this.tipoComponenteService.editarTipoComponente(this.tipoComponente).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess(`Tipo de Componente ${data.nome} editado com sucesso !`);
      this.listPageTipoComponente(this.pageAtual, 10);
      this.submit = false;
      this.formTipoComponenete.reset();
      this.tipoComponente.id = null;
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Erro ao tentar editar o tipo de componente !');
    });
  }

  editarModulo(tipoComponente: TipoComponenteModel) {
    this.tipoComponente = { ...tipoComponente};
  }

  apagarTipoComponenteDialog(tipoComponenteId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este tipo de componente ?', from: 'tipo-componente.component.ts'}
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.apagarTipoComponente(tipoComponenteId);
      }
    });
  }

  apagarTipoComponente(tipoComponenteId: Number) {
    this.tipoComponenteService.apagarTipoComponente(tipoComponenteId).subscribe(() => {
      this.openSnackBarSuccess('Tipo de Componente excluído com sucesso !');
      this.listarTipoComponente();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar excluír o tipo de componente !');
    });
  }

  changePage(event) {
    this.listPageTipoComponente(event.page, event.size);
    this.pageAtual = event.page;
   }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  onSubmit() {
    this.submit = true;
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorTipoComponente = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorTipoComponente = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaTipoComponente = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaTipoComponente = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/tipo-componente/tipo-componente.component.ts